import type { Game } from './stores/games';

export const sleep = async (waitTime: number) =>
  new Promise((resolve) => setTimeout(resolve, waitTime));

/**
 * Creates a Deep Copy of a serializable object.
 *
 * Why in the world is this the best way to get a deep copy
 * of a javascript object in TYOOL 2023?
 *
 * @param obj A JSON-serializable data structure
 * @returns A deep copy of the given object
 */
export function clone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Only execute the function after a certain amount of time since the
 * last time it was called. Useful for noisey callbacks like resive.
 *
 * @param func any function
 * @param timeout the duration you want to wait before executing the function
 * @returns A debounced version fo the function.
 */
export function debounce(func: (...args: any[]) => any, timeout: number) {
  let timeoutId: number;
  return (...fArgs: any[]) => {
    if (timeout) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...fArgs);
    }, timeout);
  };
}

export function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}

export function gameTitle(g: Game): string {
  if (g.is_mod) {
    return `${g.mod_name} (${g.title} mod)`;
  }
  return g.title;
}
